module.exports = __webpack_public_path__ + "media/lobby_normal3.247213f8.mp3";